import { Badge } from '#app/components/ui/badge'
import { cn } from '#app/utils/misc'

export function CourseCardBadge({
	label,
	className,
}: {
	label: string
	className?: string
}) {
	return (
		<Badge
			variant="outline"
			title={label}
			className={cn(
				'h-6 max-w-full min-w-0 overflow-hidden rounded-full px-2.5 text-xs font-medium',
				className,
			)}
		>
			<span className="block min-w-0 truncate">{label}</span>
		</Badge>
	)
}
